// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.transact-trade-backdrop[data-v-1b94eea4] {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  z-index: 98;
  top: 0px;
  left: 0px;
  height: 100vh;
}
.transact-trade-footer[data-v-1b94eea4] {
  border-top: 1px solid #ddd;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}
.transact-trade-pop[data-v-1b94eea4] {
  position: fixed;
  overflow-y: hidden;
  width: 80vw;
  background: #fff;
  top: 5vh;
  bottom: 5vh;
  left: 10vw;
  z-index: 99;
}
.transact-trade-header[data-v-1b94eea4] {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 52px;
  box-shadow: 1px 2px 4px #eee;
  border-bottom: 1px solid #eee;
}
.transact-trade-header > div[data-v-1b94eea4] {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -9px;
}
.transact-trade-body[data-v-1b94eea4] {
  padding: 20px;
  overflow: auto;
}
.close-icon[data-v-1b94eea4] {
  color: #bdbcbc;
}
.close-icon[data-v-1b94eea4]:hover {
  text-decoration: none;
  color: #bdbcbc;
}
@media (min-width: 1366px) {
.transact-trade-body[data-v-1b94eea4] {
    max-height: 75vh;
}
}
@media (max-width: 1366px) {
.transact-trade-body[data-v-1b94eea4] {
    max-height: 65vh;
}
}
@media (max-width: 1024px) {
.transact-trade-body[data-v-1b94eea4] {
    max-height: 75vh;
}
}
@media (max-width: 740px) {
.transact-trade-pop[data-v-1b94eea4] {
    top: 2vh;
    left: 2vw;
    width: 96vw;
}
}
@media (max-width: 580px) {
.transact-trade-body[data-v-1b94eea4] {
    max-height: 65vh;
}
}
@media (max-width: 330px) {
.transact-trade-footer .transact-buttons h3[data-v-1b94eea4] {
    font-size: 1em !important;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/KellyBlueBook/KbbTrimSelectModal/KbbTrimSelectModal.vue"],"names":[],"mappings":";AAyBA;EACE,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;AACb;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AAEA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AAEA;AACE;IACE,gBAAgB;AAClB;AACF;AACA;AACE;IACE,gBAAgB;AAClB;AACF;AACA;AACE;IACE,gBAAgB;AAClB;AACF;AACA;AACE;IACE,QAAQ;IACR,SAAS;IACT,WAAW;AACb;AACF;AACA;AACE;IACE,gBAAgB;AAClB;AACF;AAEA;AACE;IACE,yBAAyB;AAC3B;AACF","sourcesContent":["<template>\r\n  <div>\r\n    <div class=\"transact-trade-backdrop\" />\r\n    <div class=\"transact-trade-pop\">\r\n      <div class=\"transact-trade-header\">\r\n        <div :class=\"isMobile ? 't-20' : ''\">\r\n          <div class=\"\" style=\"width: 12%\">\r\n            <img alt=\"kelley Blue Book\" src=\"/images/kelley-blue-book.png\" class=\"w-100\" />\r\n          </div>\r\n          <div class=\"m-0\" style=\"font-size: 1.5em\">KBB Trade Value</div>\r\n        </div>\r\n        <div class=\"position-absolute\" style=\"right: 20px; top: 30px\">\r\n          <a class=\"close-icon\" href=\"\" @click.prevent=\"onCloseClick()\">\r\n            <em class=\"primaryicon-times\"\r\n          /></a>\r\n        </div>\r\n      </div>\r\n      <div class=\"transact-trade-body\">\r\n        <kbb-trim-select />\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n<script type=\"text/javascript\" src=\"./KbbTrimSelectModal.js\"></script>\r\n<style scoped>\r\n.transact-trade-backdrop {\r\n  position: fixed;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: 100vw;\r\n  z-index: 98;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100vh;\r\n}\r\n\r\n.transact-trade-footer {\r\n  border-top: 1px solid #ddd;\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: #fff;\r\n}\r\n.transact-trade-pop {\r\n  position: fixed;\r\n  overflow-y: hidden;\r\n  width: 80vw;\r\n  background: #fff;\r\n  top: 5vh;\r\n  bottom: 5vh;\r\n  left: 10vw;\r\n  z-index: 99;\r\n}\r\n\r\n.transact-trade-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 52px;\r\n  box-shadow: 1px 2px 4px #eee;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.transact-trade-header > div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: absolute;\r\n  top: -9px;\r\n}\r\n\r\n.transact-trade-body {\r\n  padding: 20px;\r\n  overflow: auto;\r\n}\r\n\r\n.close-icon {\r\n  color: #bdbcbc;\r\n}\r\n.close-icon:hover {\r\n  text-decoration: none;\r\n  color: #bdbcbc;\r\n}\r\n\r\n@media (min-width: 1366px) {\r\n  .transact-trade-body {\r\n    max-height: 75vh;\r\n  }\r\n}\r\n@media (max-width: 1366px) {\r\n  .transact-trade-body {\r\n    max-height: 65vh;\r\n  }\r\n}\r\n@media (max-width: 1024px) {\r\n  .transact-trade-body {\r\n    max-height: 75vh;\r\n  }\r\n}\r\n@media (max-width: 740px) {\r\n  .transact-trade-pop {\r\n    top: 2vh;\r\n    left: 2vw;\r\n    width: 96vw;\r\n  }\r\n}\r\n@media (max-width: 580px) {\r\n  .transact-trade-body {\r\n    max-height: 65vh;\r\n  }\r\n}\r\n\r\n@media (max-width: 330px) {\r\n  .transact-trade-footer .transact-buttons h3 {\r\n    font-size: 1em !important;\r\n  }\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
